// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c82e9dca","163":"edbe1ab4","236":"fc689fd0","318":"78249921","753":"b8110d6e","849":"6b8d2bf7","934":"1e79ab1c","965":"8165004c","990":"861655bd"}[chunkId] + ".chunk.js";
};